import './reward.css';
import AnimatedGiftBox from './AnimatedGiftBox';

function SparkleIcon({ className, color = '#ff9f2e' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none">
      <path d="M12 2c0 5.2-2.8 8-8 8 5.2 0 8 2.8 8 8 0-5.2 2.8-8 8-8-5.2 0-8-2.8-8-8Z" fill={color} />
    </svg>
  );
}

function ConfettiIcon({ className, color }) {
  return (
    <svg className={className} viewBox="0 0 12 12" fill="none">
      <rect x="1" y="1" width="10" height="4" rx="1.5" fill={color} />
    </svg>
  );
}

function ChevronRightIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M9 5l7 7-7 7" stroke="#ffffff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function ShareIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
      <circle cx="18" cy="5" r="2.6" stroke="#6c4ce8" strokeWidth="1.8" />
      <circle cx="6" cy="12" r="2.6" stroke="#6c4ce8" strokeWidth="1.8" />
      <circle cx="18" cy="19" r="2.6" stroke="#6c4ce8" strokeWidth="1.8" />
      <path d="M8.3 10.7 15.7 6.3M8.3 13.3l7.4 4.4" stroke="#6c4ce8" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

const STEP_COUNT = 5;

export default function Reward({ onShowDeal, onShare }) {
  const handleShare = () => {
    if (onShare) {
      onShare();
      return;
    }
    if (navigator.share) {
      navigator.share({ title: 'Zini', text: 'I just unlocked a surprise deal on Zini!' }).catch(() => {});
    }
  };

  return (
    <div className="reward-screen">
      <div className="reward-frame">
        {/* <div className="reward-stepper">
          {Array.from({ length: STEP_COUNT }, (_, i) => i + 1).map((n) => (
            <span key={n} className="reward-step-dot">
              {n}
            </span>
          ))}
        </div> */}

        <h1 className="reward-title">
          Surprise Unlocked! <span className="reward-title-emoji">🎁</span>
        </h1>
        <p className="reward-subtitle">Here&apos;s your special deal!</p>

        <div className="reward-stage">
          <div className="reward-stage-glow" />
          <SparkleIcon className="reward-sparkle reward-sparkle-1" color="#ff9f2e" />
          <SparkleIcon className="reward-sparkle reward-sparkle-2" color="#6c4ce8" />
          <SparkleIcon className="reward-sparkle reward-sparkle-3" color="#ff9f2e" />
          <ConfettiIcon className="reward-confetti reward-confetti-1" color="#17b8a6" />
          <ConfettiIcon className="reward-confetti reward-confetti-2" color="#ff3d81" />
          <ConfettiIcon className="reward-confetti reward-confetti-3" color="#ffb238" />
          <ConfettiIcon className="reward-confetti reward-confetti-4" color="#6c4ce8" />
          <ConfettiIcon className="reward-confetti reward-confetti-5" color="#17b8a6" />

          <AnimatedGiftBox />
        </div>

        <button type="button" className="reward-deal-btn" onClick={onShowDeal}>
          Show My Deal
          <span className="reward-deal-icon">
            <ChevronRightIcon />
          </span>
        </button>

        {/* <button type="button" className="reward-share-btn" onClick={handleShare}>
          <ShareIcon />
          Share with Friends
        </button> */}
      </div>
    </div>
  );
}
